export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAIL = "REGISTER_FAIL";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const USER_LOADING = "USER_LOADING";
export const USER_LOADED = "USER_LOADED";
export const AUTH_ERROR = "AUTH_ERROR";
export const GET_ERRORS = "GET_ERRORS";
export const CREATE_MESSAGE = "CREATE_MESSAGE";
export const GET_ARTICLES_REQUEST = "GET_ARTICLES_REQUEST";
export const GET_ARTICLES_SUCCESS = "GET_ARTICLES_SUCCESS";
export const GET_ARTICLES_FAIL = "GET_ARTICLES_FAIL";
export const ADD_ARTICLES_SUCCESS = "ADD_ARTICLES_SUCCESS";
export const ADD_ARTICLES_FAIL = "ADD_ARTICLES_FAIL";
export const ADD_ARTICLES_REQUEST = "ADD_ARTICLES_REQUEST";
export const ARTICLE_LOADED = "ARTICLE_LOADED";
export const ARTICLE_LOADING = "ARTICLE_LOADING";
export const FETCH_ARTICLE_FAIL = "FETCH_ARTICLE_FAIL";
